import oRequest from '../libsV2/request.js';
import storage from '@/libsV2/storage.js';

let URL = {
    GET_BLACKLIST:'/wechat/api/getsign',
    SENDSERVICE_ID:'member/access/video'
}
export const getBlackList = (data = {}) => {
    const resquestData = Object.assign({}, data);
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.GET_BLACKLIST, data).then(res => {
            if (res.data.error == 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                store.commit('loadSwitch', false);
                throw 0;
            }
        })
    })
}


export const sendSeriveId = (data = {}) => {
    const resquestData = Object.assign({}, data);
    return new Promise((resolve, recject) => {
        oRequest.getData(URL.SENDSERVICE_ID, data).then(res => {
            if (res.data.error == 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                store.commit('loadSwitch', false);
                throw 0;
            }
        })
    })
}
